export default __webpack_public_path__ + "static/media/info-blue-light.efe5fb30.svg";